module.exports = __webpack_public_path__ + "img/position.02265ca1.png";